(() => {
  if (window.frameSceneDiscoveryReady) return;
  window.frameSceneDiscoveryReady = true;
  const storageKey = 'frame-scene:recent-products:v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(value);
  const root = document.body.dataset.root || '/';
  async function getHTML(url) {
    const response = await fetch(url, { signal: AbortSignal.timeout(8000) });
    if (!response.ok) throw new Error(`Product request failed (${response.status})`);
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }
  async function recommendations(section) {
    const grid = section.querySelector('[data-discovery-grid]');
    section.hidden = !grid.querySelector('.product-card');
    const limit = Number(section.dataset.limit);
    const original = [...grid.children];
    const priority = original.slice(0, Number(section.dataset.priorityCount || 0));
    if (priority.length >= limit) return;
    try {
      const url = new URL(section.dataset.url, location.origin);
      url.search = new URLSearchParams({ section_id: section.dataset.sectionId, product_id: section.dataset.productId, limit: 10, intent: 'related' });
      const html = await getHTML(url);
      const cards = html.querySelector('[data-recommendations] [data-discovery-grid]');
      if (cards?.querySelector('.product-card')) {
        const path = url => new URL(url, location.origin).pathname.replace(/\/$/, '');
        const seen = new Set([path(section.dataset.productUrl || location.pathname)]);
        const selected = [];
        for (const card of [...priority, ...cards.children, ...original]) {
          const link = card.querySelector('a[href]');
          if (!link) continue;
          const key = path(link.href);
          if (seen.has(key)) continue;
          seen.add(key); selected.push(card);
          if (selected.length >= limit) break;
        }
        if (selected.length) { grid.replaceChildren(...selected); section.hidden = false; }
      }
    } catch (error) { console.warn('Recommendations unavailable; keeping collection suggestions.', error); }
  }
  async function recent(section) {
    const current = section.dataset.handle;
    if (!validHandle(current)) return;
    let previous;
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
      const cutoff = Date.now() - 30 * 24 * 60 * 60 * 1000;
      previous = (Array.isArray(saved) ? saved : []).filter(item => validHandle(item?.handle) && item.handle !== current && Number(item.time) > cutoff);
      previous = previous.filter((item, index, all) => all.findIndex(other => other.handle === item.handle) === index).slice(0, 12);
      localStorage.setItem(storageKey, JSON.stringify([{ handle: current, time: Date.now() }, ...previous].slice(0, 12)));
    } catch (error) { console.warn('Recently viewed storage is unavailable.', error); return; }
    if (!previous.length) return;
    const results = await Promise.allSettled(previous.slice(0, Number(section.dataset.limit)).map(async item => {
      const url = new URL(`${root}products/${encodeURIComponent(item.handle)}`, location.origin);
      url.searchParams.set('section_id', 'recent-product-card');
      const html = await getHTML(url);
      return html.querySelector('.product-card');
    }));
    const grid = section.querySelector('[data-discovery-grid]');
    for (const result of results) {
      if (result.status === 'fulfilled' && result.value) grid.append(result.value);
      else if (result.status === 'rejected') console.warn('A recently viewed product could not be loaded.', result.reason);
    }
    section.hidden = !grid.children.length;
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-recommendations], [data-recently-viewed]').forEach(section => {
      if (section.dataset.discoveryReady) return;
      section.dataset.discoveryReady = 'true';
      if (section.hasAttribute('data-recommendations')) recommendations(section);
      else recent(section);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
